import { render, staticRenderFns } from "./StoreDetailView.vue?vue&type=template&id=fec44db4&lang=pug&"
import script from "./StoreDetailView.vue?vue&type=script&lang=js&"
export * from "./StoreDetailView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports